import { change } from 'redux-form';
import { replace } from 'react-router-redux';

import { handleErrorException, loading, success, error } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { CREATE_EDIT_PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import { CreateEditPhysicalEnum, FilterEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const emptyItemList = () => {
  return {
    type: types.CREATE_EDIT_PHYSICAL_ITEMS,
    payload: [],
  };
};

export const getPhysicalItems = (
  filterOptions,
  isReOrderItemList,
  infoList,
  isLoadOnHandClicked
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PHYSICAL_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Physical/LoadPhysicalItems',
        filterOptions
      );
      isLoadOnHandClicked && dispatch(clearInvalidPreviewData([]));
      dispatch(success(types.CREATE_EDIT_PHYSICAL_ITEMS, response.data.Data));
      if (isReOrderItemList && infoList) {
        dispatch(reorderItemList(infoList));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Physical Items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.PHYSICAL_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.PHYSICAL_LOADING, false));
    }
  };
};

export const getOnHandItems = filterOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_PHYSICAL_ON_HAND, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Physical/GetPhysicalOnHandItems',
        filterOptions
      );
      dispatch(success(types.PHYSICAL_ON_HAND_DETAIL, response.data.Data));
      dispatch(
        change(
          CREATE_EDIT_PHYSICAL_FORM_NAME,
          CreateEditPhysicalEnum.PhysicalItemsInfo,
          response.data.Data
        )
      );
      if (response.data.Data) {
        dispatch(reorderItemList(response.data.Data));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Physical Detail. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_PHYSICAL_ON_HAND_ERROR,
          defaultError
        )
      );
      dispatch(setIsLoadOnHandClicked(true));
    } finally {
      dispatch(loading(types.FETCHING_PHYSICAL_ON_HAND, false));
    }
  };
};

export const reorderItemList = items => {
  return {
    type: types.RE_PHYSICAL_ITEM_LIST,
    payload: items,
  };
};

export const clearInvalidPreviewData = data => {
  return async dispatch => {
    dispatch(
      change(
        CREATE_EDIT_PHYSICAL_FORM_NAME,
        CreateEditPhysicalEnum.PhysicalItemsInfo,
        data
      )
    );
  };
};

export const emptyEditObject = () => {
  return {
    type: types.SELECTED_PHYSICAL_DETAIL,
    payload: null,
  };
};

export const resetFilterOnClickOfPreviousPage = () => {
  return async dispatch => {
    dispatch(
      change(CREATE_EDIT_PHYSICAL_FORM_NAME, [FilterEnum.GroupId_Bid], 0)
    );
    dispatch(
      change(CREATE_EDIT_PHYSICAL_FORM_NAME, [FilterEnum.GroupId_Item], 0)
    );
    dispatch(
      change(CREATE_EDIT_PHYSICAL_FORM_NAME, [FilterEnum.GroupId_Location], 0)
    );
  };
};

export const clearPhysicalSubmitError = () => {
  return {
    type: types.CLEAR_PHYSICAL_ERROR_SUCCESS,
  };
};

export const savePhysical = (model, resetScroll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_PHYSICAL_DETAIL, true));
    resetScroll();
    model = {
      ...model,
    };
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'physical/Create',
        model
      );
      dispatch(resetDirty());

      if (response.data.Data.Title === CreateEditPhysicalEnum.Error) {
        dispatch(error(types.SUBMIT_PHYSICAL_DETAIL_ERROR, response.data.Data));
      } else {
        dispatch(success(types.PHYSICAL_DETAIL_SUBMIT));
        dispatch(replace('/physical'));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving Physical. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SUBMIT_PHYSICAL_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_PHYSICAL_DETAIL, false));
    }
  };
};

export const updatePhysical = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_PHYSICAL_DETAIL, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'physical/Update',
        model
      );
      dispatch(resetDirty());
      if (response.data.Data.Title === CreateEditPhysicalEnum.Error) {
        dispatch(error(types.SUBMIT_PHYSICAL_DETAIL_ERROR, response.data.Data));
      } else {
        dispatch(success(types.PHYSICAL_DETAIL_SUBMIT));
        dispatch(replace('/physical'));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while saving Physical. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SUBMIT_PHYSICAL_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_PHYSICAL_DETAIL, false));
    }
  };
};

export const getPhysicalDetail = physicalID => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCHING_PHYSICAL_DETAIL, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `Physical/GetPhysicalDetail/${physicalID}`
      );
      dispatch(success(types.SELECTED_PHYSICAL_DETAIL, response.data.Data));
      dispatch(
        success(
          types.CREATE_EDIT_PHYSICAL_ITEMS,
          response.data.Data['PhysicalItems']
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching Physical Detail. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCHING_PHYSICAL_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCHING_PHYSICAL_DETAIL, false));
    }
  };
};

export const checkIncompletePhysicals = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric(
        `Physical/GetIncompletePhysicalsError`
      );
      dispatch(
        success(types.CHECK_INCOMPLETE_PHYSICAL_RESULT, {
          message: response.data.Data.Message,
          isError: false,
        })
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching incomplete physicals. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.CHECK_INCOMPLETE_PHYSICAL_ERROR,
          defaultError
        )
      );
    }
  };
};

export const getSiteWarningData = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITE_WARNING_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Physical/SiteWarningCheck`,
        model
      );

      if (response.data.Data.Title === TitleEnum.Error) {
        dispatch(error(types.SITE_WARNING_ERROR, response.data.Data));
      } else {
        dispatch(
          success(
            types.SITE_WARNING_CHECK,
            response.data.Data ? response.data.Data : []
          )
        );
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while site warning data. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SITE_WARNING_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SITE_WARNING_DATA_LOADING, false));
    }
  };
};

export const emptyOnHandDetails = () => {
  return {
    type: types.PHYSICAL_ON_HAND_DETAIL,
    payload: null,
  };
};

export const setIsLoadOnHandClicked = payload => {
  return {
    type: types.SET_IS_LOAD_ONHAND_CLICKED,
    payload,
  };
};

export const clearSiteWarningData = () => {
  return { type: types.CLEAR_SITE_WARNING_DATA };
};
export const clearSiteWarningDataError = () => {
  return { type: types.CLEAR_SITE_WARNING_DATA_LOADING_ERROR };
};

export const clearPhysicalInfoGridData = () => {
  return change(
    CREATE_EDIT_PHYSICAL_FORM_NAME,
    CreateEditPhysicalEnum.PhysicalItemsInfo,
    []
  );
};

export const setModifiedPhysicalItems = newData => {
  return change(
    CREATE_EDIT_PHYSICAL_FORM_NAME,
    CreateEditPhysicalEnum.PhysicalItemsInfo,
    newData
  );
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/CreateEditPhysical/actions.js